import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import { getStyle, getStylePath } from "@builder/components/editable/helpers";
import ColorInput from "@builder/components/general/ColorInput";
import SliderInput from "@builder/components/general/SliderInput/index";
import { getValueUnit } from "@builder/components/general/editUtils";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { SimpleCartNode } from "@common/build/types";

const StyleSimpleCart = ({ excluded, condition, parent, stateMode }: EditableProps) => {
    const dispatch = useAppDispatch();
    const activeNode = useAppSelector(state => state.builder.activeNode);
    const node = useAppSelector(getSelectedNode) as SimpleCartNode;
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const cvModeIndex = cvMode?.id === node?.id ? cvMode.index : null;

    //Width
    const widthString = getStyle(node, ["expandedNode", "cartWidth"], stateMode, cvModeIndex);
    const cartWidth = getValueUnit(widthString.stateStyle || widthString.default);
    const widthPath = getStylePath(["expandedNode", "cartWidth"], stateMode, cvModeIndex);
    const cartWidthUpdate = (value: string, unit: string): void => {
        dispatch(updateNodeProperty({ propertyPath: widthPath, value: value + unit }));
    };

    //Height
    let heightElem = null;
    if (!excluded?.includes("height")) {
        const heightString = getStyle(node, ["expandedNode", "cartHeight"], stateMode, cvModeIndex);
        const cartHeight = getValueUnit(heightString.stateStyle || heightString.default);
        const heightPath = getStylePath(["expandedNode", "cartHeight"], stateMode, cvModeIndex);
        const heightCallback = (value: string, unit: string) => {
            dispatch(updateNodeProperty({ propertyPath: heightPath, value: value + unit }));
        };
        heightElem = <SliderInput title="Height" min={300} max={1000} callback={heightCallback} {...cartHeight} />;
    }

    //MainBg
    const mainBg = getStyle(node, ["expandedNode", "mainBg"], stateMode, cvModeIndex);
    const mainBgPath = getStylePath(["expandedNode", "mainBg"], stateMode, cvModeIndex);
    const updateMainBg = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: mainBgPath, value }));
    };

    //TotalBg
    const totalBg = getStyle(node, ["expandedNode", "totalBg"], stateMode, cvModeIndex);
    const totalBgPath = getStylePath(["expandedNode", "totalBg"], stateMode, cvModeIndex);
    const updateTotalBg = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: totalBgPath, value }));
    };

    //DividerColor
    const dividerColor = getStyle(node, ["expandedNode", "dividerColor"], stateMode, cvModeIndex);
    const dividerColorPath = getStylePath(["expandedNode", "dividerColor"], stateMode, cvModeIndex);
    const updateDividerBg = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: dividerColorPath, value }));
    };

    if (condition && (!node || !condition(node, activeNode))) return null;
    //colors.stateStyle?.[index] || colors.default?.[index] || color
    return (
        <SidebarCollapse title="Cart styling" parent={parent}>
            <ColorInput title="Main section background" color={mainBg.stateStyle || mainBg.default} callback={updateMainBg} />
            <ColorInput title="Total background" color={totalBg.stateStyle || totalBg.default} callback={updateTotalBg} />
            <ColorInput title="Divider lines color" color={dividerColor.stateStyle || dividerColor.default} callback={updateDividerBg} />
            <SliderInput title="Width" min={300} max={800} callback={cartWidthUpdate} value={cartWidth.value} unit={cartWidth.unit} />
            {heightElem}
        </SidebarCollapse>
    );
};

export default StyleSimpleCart;
